/**
 * generate metaData computed for the search view
 */

// eslint-disable-next-line import/no-unresolved
import { computed } from '@vue/composition-api';
import StateProviderSetup from 'mixins/composition/search/StateProvider';

export default ({ app, store }) => {
  const {
    isSeoPage, isSeaPage, totalObjects, seoContent, isPlace, locationTitle, locationBreadcrumbs,
  } = StateProviderSetup({ app, store });

  return computed(() => {
    const links = [];

    let robots = 'index, follow';
    let searchType = '';
    if (seoContent.value.noIndex === 1) {
      robots = 'noindex, follow';
    } else if (isSeoPage.value) {
      // EDVUE-1746 dont decide with totalObject if search request hast return with error (4..,5.. aso)
      if (store.state.searchHasErrors !== true) {
        if (store.getters.getSearchLocationFilter('country')) {
          searchType = 'country';
        }
        if (store.getters.getSearchLocationFilter('region')) {
          searchType = 'location';
        }
        if (store.getters.getSearchLocationFilter('location')) {
          searchType = 'location';
        }
        if (store.getters.getSearchLocationFilter('place')) {
          searchType = 'location';
        }
        if (searchType === 'country' && totalObjects.value < 10) {
          robots = 'noindex, follow';
        }
        if (searchType === 'location' && totalObjects.value < 3) {
          robots = 'noindex, follow';
        }
      }
    } else {
      robots = 'noindex, follow';
    }

    // set cononical
    if ((robots !== 'noindex, follow' && isSeoPage.value) || isSeaPage.value) {
      if (store.state.app.addCanonical) links.push({ vmid: 'canonical', rel: 'canonical', href: `https://product.${process.env.CLIENTNAME}${store.state.route.path}` });
    }

    if (robots !== 'noindex, follow') {
    // links to alternative domain/languages
      const actLangLinks = seoContent.value.languageLinks;
      if (actLangLinks && Object.entries(actLangLinks).length > 1) {
        Object.entries(actLangLinks).forEach((languageLink) => {
          links.push(
            {
              vmid: `alt_${languageLink[0]}`, rel: 'alternate', hreflang: languageLink[0], href: languageLink[1],
            },
          );
        });
      }
    }
    const breadcrumbs = locationBreadcrumbs.value;
    let { metaDescription } = seoContent.value;
    if (!metaDescription) {
      // use correct property 'totalObjects' only if count > 0, otherwise use fake property (doesnt exists) to prevent 0 as text in json
      const key = totalObjects.value > 0 ? 'totalObjects' : 'other';
      if (isPlace.value) {
        metaDescription = app.$t('common:metaLanding.description.location', {
          locationWithPreposition: locationTitle.value?.titlePrepo || '',
          country: breadcrumbs.length ? breadcrumbs[0].label : '',
          [key]: totalObjects.value
        });
      } else if (store.getters.getSearchLocationFilter('region')) {
        metaDescription = app.$t('common:metaLanding.description.region', {
          regionWithPreposition: locationTitle.value?.titlePrepo || '',
          country: breadcrumbs.length ? breadcrumbs[0].label : '',
          [key]: totalObjects.value
        });
      } else {
        metaDescription = app.$t('common:metaLanding.description.country', {
          countryWithPreposition: locationTitle.value?.titlePrepo || '',
          [key]: totalObjects.value
        });
      }
    }

    let { metaTitle } = seoContent.value;
    if (!metaTitle) {
      if (isPlace.value) {
        metaTitle = app.$t('common:metaLanding.title.location', {
          locationWithPreposition: locationTitle.value?.titlePrepo || '',
          country: breadcrumbs.length ? breadcrumbs[0].label : '',
        });
      } else if (store.getters.getSearchLocationFilter('region')) {
        metaTitle = app.$t('common:metaLanding.title.region', {
          locationWithPreposition: locationTitle.value?.titlePrepo || '',
          country: breadcrumbs.length ? breadcrumbs[0].label : '',
        });
      } else {
        metaTitle = app.$t('common:metaLanding.title.country', {
          locationWithPreposition: locationTitle.value?.titlePrepo || '',
        });
      }
    }

    return {
      title: metaTitle,
      titleTemplate: null,
      meta: [
        { vmid: 'description', name: 'description', content: metaDescription },
        { vmid: 'name', name: 'keywords', content: seoContent.value.metaKeywords },
        { vmid: 'og_title', property: 'og:title', content: metaTitle },
        { vmid: 'og_description', property: 'og:description', content: metaDescription },
        // { vmid: 'og_url', property: 'og:url', content: '' },
        // { vmid: 'og_image', property: 'og:image', content: '' },
        { vmid: 'og_type', property: 'og:type', content: 'website' },
        { vmid: 'robots', name: 'robots', content: robots },
      ],
      link: links,
    };
  });
};
